import { CONTENT_TYPES } from "@gonoodle/gn-universe-analytics-schema/src/constants";

const contentTypeToEndpoint = {
  [CONTENT_TYPES.ACTIVITY]: "printables",
  [CONTENT_TYPES.VIDEO]: "videos",
};

export default ({ get, post, del, checkStatus, toJSON }) => ({
  getFavorites: () =>
    get(`universe/v1/favorites`).then(checkStatus).then(toJSON),
  favorite: ({ type, id }) =>
    post(`universe/v1/${contentTypeToEndpoint[type]}/${id}/favorite`),
  unfavorite: ({ type, id }) =>
    del(`universe/v1/${contentTypeToEndpoint[type]}/${id}/favorite`),
});
